import React from 'react';
import PermissionMatrix from './PermissionMatrix';

const Master = (props) => (
  <PermissionMatrix
    {...props}
    areaLabel="Master"
    hierarchy={['Master']}
    disabledFeatureKeys={['system.access_management']}
    useWildcardFallback
  />
);

export default Master;
